import { withTheme, SvyIcon as Icon } from '@innovorder/savory';

export const SvyIcon = withTheme(Icon);
